import { render, staticRenderFns } from "./SupervisorDashboard2.vue?vue&type=template&id=71c8f1f0&scoped=true&"
import script from "./SupervisorDashboard2.vue?vue&type=script&lang=js&"
export * from "./SupervisorDashboard2.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorDashboard2.vue?vue&type=style&index=0&id=71c8f1f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c8f1f0",
  null
  
)

export default component.exports